"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TripFinancialDashboardOutput = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const price_output_1 = require("../../commons/output/price.output");
class TripFinancialDashboardOutput {
}
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], TripFinancialDashboardOutput.prototype, "initialSellPrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], TripFinancialDashboardOutput.prototype, "initialBuyPrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], TripFinancialDashboardOutput.prototype, "initialMargin", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripFinancialDashboardOutput.prototype, "initialMarginRate", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], TripFinancialDashboardOutput.prototype, "finalSellPrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], TripFinancialDashboardOutput.prototype, "finalBuyPrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], TripFinancialDashboardOutput.prototype, "netDriverPrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], TripFinancialDashboardOutput.prototype, "outsourcing", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], TripFinancialDashboardOutput.prototype, "dedicatedPackagePrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], TripFinancialDashboardOutput.prototype, "rfaPrice", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripFinancialDashboardOutput.prototype, "rfaRate", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], TripFinancialDashboardOutput.prototype, "additionalFeesPrice", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripFinancialDashboardOutput.prototype, "additionalFeesRate", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripFinancialDashboardOutput.prototype, "brutMarginRate", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], TripFinancialDashboardOutput.prototype, "brutMargin", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], TripFinancialDashboardOutput.prototype, "customerRemuneration", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], TripFinancialDashboardOutput.prototype, "customerRemunerationRate", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => price_output_1.PriceOutput),
    __metadata("design:type", price_output_1.PriceOutput)
], TripFinancialDashboardOutput.prototype, "finalMargin", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripFinancialDashboardOutput.prototype, "finalMarginRate", void 0);
exports.TripFinancialDashboardOutput = TripFinancialDashboardOutput;
